export const openCasinoProviderModal = (activeTab) => {
	const isLive = activeTab === "LiveCasino" || activeTab === "livecasino";

	window.dispatchEvent(
		new CustomEvent("openCasinoProviderModal", {
			detail: { open: true, isLive },
		})
	);
};

export const closeCasinoProviderModal = () => {
	window.dispatchEvent(
		new CustomEvent("openCasinoProviderModal", {
			detail: { open: false },
		})
	);
};

export const openCasinoSearchModal = () => {
	window.dispatchEvent(
		new CustomEvent("openCasinoSearchModal", {
			detail: { open: true },
		})
	);
};
